import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVisit } from '../api/visits';
import { Visit } from '../types/visit';
import { useToast } from '../../../hooks/use-toast';

export function useCancelVisit() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (visitId: string) => {
      const visit = await updateVisit({
        id: visitId,
        status: 'cancelled'
      } as Visit);
      return visit;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['visits'] });
      toast({
        title: "Visit cancelled",
        description: "The follow-up visit has been cancelled successfully.",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: "Failed to cancel the visit. Please try again.",
        variant: "destructive",
      });
      console.error('Failed to cancel visit:', error);
    },
  });
}
